export default __webpack_public_path__ + "static/media/OmidIntro.6dc243f9.mp4";